import { useSelector } from 'react-redux';
import {
  getDataPresentation,
  getDataTable,
  getRowsHeadings,
  getShowChartingOptions,
} from '@/store-selectors';
import DataTableHeading from '@/util/DataTableHeading';
import { ChartType } from '@/components/charting/types';
import {
  changeDataPresentation,
  layerUserInteraction,
  openReactModal,
} from '@/actions';
import { CREATE_CHART } from '@/components/HighlightFeature';
import ChartHint from '@/components/ChartHint';
import React from 'react';
import { ChartToggle } from '@/components/ChartToggle';
import { userAction } from '@/util/helpers/ajax-helpers';
import { useAppDispatch } from '@/store/hooks';

export const useDeriveHeadings = () => {
  const dataTable = useSelector(getDataTable);
  const rowsHeadings = useSelector(getRowsHeadings);

  return (
    dataTable?.headings() ??
    rowsHeadings?.map((c) => DataTableHeading.fromColumn(c))
  );
};

export const useHandlePresentationChange = (presentation: ChartType) => {
  const dispatch = useAppDispatch();
  const areChartingOptionsShown = useSelector(getShowChartingOptions);

  return () => {
    if (!areChartingOptionsShown) {
      dispatch(
        layerUserInteraction({ event: 'toggle-charting', newValue: true }),
      );
    }
    userAction(CREATE_CHART + presentation);
    dispatch(changeDataPresentation(presentation));
  };
};

export const useHandleDisabledPresentationClick = (presentation: ChartType) => {
  const dispatch = useAppDispatch();

  return () => {
    userAction(`open-disabled-chart-modal-${presentation}`);
    dispatch(openReactModal(<ChartHint presentation={presentation} />));
  };
};

export const useDerivePresentation = (headings: any) => {
  const dataPresentation = useSelector(getDataPresentation);

  return ChartToggle.parsePresentation(headings, dataPresentation);
};
